<template>
  <div class="ly_tooltip" :style="{zIndex: isView ? 1 : 0}">
    <span @mouseover="isView = true" @mouseout="isView = false" :class="[status ? 'lamp red' : 'text']">
      <slot />
    </span>
    <dl v-if="isView" class="msg">
      <slot name="content" />
    </dl>
  </div>
</template>

<script>
export default {
  props: ['status'],
  data() {
    return {
      isView: false
    }
  }
}
</script>

